import styled from '@emotion/styled';

export const BodyWrapper = styled.div`
  & > label {
    height: 48px;
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 35px;
    margin-right: 5px;
    color: #999999;
    &:nth-last-of-type(1) {
      color: #333333;
    }
    &:nth-of-type(n + 2) {
      &:before {
        color: #999999;
        content: '>';
        font-weight: bold;
        margin: 0 7px;
      }
    }
    & .sub-title {
      margin-left: 10px;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      color: #666;
    }
  }
`;
export const Body = styled.div`
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
  &[data-page-type='table-only'] {
    padding: 0;
    background: unset;
    table {
      width: 100%;
      margin: 0;
    }
  }
  table {
    margin: 20px 95px 60px 20px;
    thead > tr > td {
      padding: 0;
    }
    tbody > tr > td {
      background-color: #ffffff;
      & .deleted {
        cursor: auto;
        color: #000 !important;
        text-decoration: none;
      }
    }
    tfoot > tr > td {
      padding: 0;
      text-align: right;
      color: #999999;
    }
    tfoot {
      position: absolute;
      right: 40px;
      bottom: 19px;
    }
  }
  @media (max-width: 412px) {
    flex-direction: column;
    max-width: 100vw;
    min-width: unset;
    align-items: center;
    height: 100%;
  }
`;
